// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3Xsb4","sendOtp":"AuthorizeToLogin_sendOtp__1BHTi"};